import { render, staticRenderFns } from "./Uploads.vue?vue&type=template&id=2fc0ff82&"
import script from "./Uploads.vue?vue&type=script&lang=ts&"
export * from "./Uploads.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports